import React from "react"
import styled, { keyframes } from "styled-components"

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const Container = styled.div`
  svg {
    width: 100%;
    height: auto;
    transform-origin: center center;
    animation: ${rotate} 10s linear infinite;
    .st0 {
      fill: #29b2a0;
    }
  }
`

const Stoked = ({ ...props }) => {
  return (
    <Container {...props}>
      <svg x="0px" y="0px" viewBox="0 0 310.9 314.7">
        <g>
          <path
            className="st0"
            d="M49.9,115.6c2.8,0.6,5.1,1.6,6.9,3.2c1.8,1.6,3.1,3.4,4,5.7c0.9,2.2,1.4,4.8,1.5,7.7c0.1,2.9-0.2,5.9-0.8,9
		c-0.3,1.7-0.8,3.4-1.2,5c-0.5,1.6-1,3.2-1.5,4.6c-0.5,1.4-1.1,2.8-1.7,4c-0.6,1.2-1.2,2.2-1.7,3.1l-14.4-1.8l0.1-0.6
		c2.1-0.9,4.2-1.8,6.2-2.7c2-1,3.9-2,5.6-3.2c1.7-1.2,3.1-2.5,4.3-3.9c1.2-1.4,1.9-3.1,2.3-4.9l0.2-1.1c0.3-1.5,0.3-2.9,0-4.1
		c-0.3-1.2-0.8-2.3-1.5-3.2c-0.7-0.9-1.5-1.6-2.4-2.2c-0.9-0.6-1.9-0.9-2.9-1.1c-1.3-0.3-2.6-0.1-3.8,0.4c-1.2,0.5-2.5,1.3-3.7,2.3
		c-1.2,1-2.4,2.2-3.6,3.6c-1.2,1.4-2.4,2.9-3.6,4.4c-1.4,1.7-2.9,3.4-4.4,5.1c-1.5,1.7-3.1,3.1-4.8,4.3c-1.7,1.2-3.4,2.1-5.3,2.7
		c-1.9,0.6-3.9,0.7-6.1,0.2c-2.6-0.5-4.8-1.5-6.5-3.1c-1.7-1.5-3-3.4-3.8-5.6c-0.9-2.2-1.3-4.7-1.4-7.5c-0.1-2.8,0.2-5.7,0.8-8.8
		l0-0.1c0.3-1.4,0.6-2.7,1.1-4.1c0.4-1.4,0.9-2.7,1.4-3.9c0.5-1.2,1.1-2.4,1.6-3.5c0.6-1.1,1.1-2.1,1.6-2.9l13.9,1.7l-0.1,0.5
		c-0.8,0.2-1.9,0.6-3.3,1.1c-1.4,0.5-2.9,1.2-4.4,2c-1.5,0.8-3,1.7-4.5,2.8c-1.5,1.1-2.7,2.2-3.7,3.5c-0.6,1.1-1,2.1-1.3,3
		c-0.2,0.9-0.4,1.8-0.6,2.6c-0.2,1.2-0.2,2.3,0,3.3c0.2,1,0.6,1.9,1.1,2.7c0.6,0.8,1.2,1.5,2.1,2c0.8,0.6,1.8,0.9,2.8,1.1
		c1.3,0.3,2.6,0.1,3.9-0.5c1.2-0.6,2.5-1.5,3.6-2.6c1.2-1.1,2.3-2.3,3.4-3.7c1.1-1.4,2.2-2.8,3.2-4.1c1.4-1.9,2.9-3.6,4.4-5.3
		c1.5-1.7,3.1-3.1,4.8-4.3c1.7-1.2,3.6-2,5.6-2.5C45.3,115.1,47.5,115.1,49.9,115.6z"
          />
          <path
            className="st0"
            d="M56.7,41l11.5,9.8L67.9,51L57,50.9c-3.7,0-7.3,1.6-9.7,4.4l26.9,22.9c4.5,3.8,9.9,6.3,15.7,7.2l0.5,0.4
		l-16.1,18.8l-0.5-0.4C72,98.8,68.7,93.8,64.3,90L37.3,67.1c-2.4,2.8-3.4,6.5-2.8,10.1L36.4,88l-0.3,0.3l-11.5-9.8L56.7,41z"
          />
          <path
            className="st0"
            d="M157.4,57.1l0.2,0.6l-27.4,7.8l-0.2-0.6l0.2-0.5c2.1-5.3,1.4-11.2-1.9-15.8L109,54.1l-0.1,1.5
		c-0.2,6.1,4.1,10,6.7,11.7l1.9,1.1l0.2,0.6l-16.3,4.7l-0.2-0.6c2.9-6,4.7-12.4,5.4-19l1.9-20.7c0.6-6.1-1.7-12.1-6.2-16.3l-0.2-0.6
		l17.1-4.9l24.6,32.1C147.6,48.8,152.2,53.3,157.4,57.1z M109.2,51.7l17.6-5L111.7,26l-0.2-0.2L109.2,51.7L109.2,51.7z"
          />
          <path
            className="st0"
            d="M222.2,20.4l-0.2,0.7c-6.8,3.4-13.1,7.7-18.6,12.9l-8.6,8.1l-2.5,9.2c-1.5,5.7-1.5,11.6,0.2,17.3l-0.2,0.6
		l-23.9-6.5l0.2-0.6c4.3-4.1,7.4-9.2,8.9-14.9c1.2-4.5,1.2-9.2,0-13.7l-2.4-8.9c-1.7-6-3.9-11.9-6.8-17.5l-0.4-0.7l0.2-0.7l27.9,7.5
		l-0.2,0.7l-0.6,0.6c-1.6,1.6-5.7,6.7-3.6,14.9l2.5,10.1l7.7-7.3c4.4-4.1,5.5-10.5,2.9-16l0.2-0.7L222.2,20.4z"
          />
          <path
            className="st0"
            d="M262,122.7c-2.5,1.4-4.9,2.1-7.3,2c-2.4,0-4.6-0.6-6.8-1.7s-4.2-2.8-6.1-4.9c-1.9-2.1-3.6-4.6-5.2-7.4
		c-0.8-1.5-1.6-3.1-2.3-4.6c-0.7-1.6-1.3-3.1-1.8-4.5c-0.5-1.5-0.9-2.8-1.3-4.1c-0.3-1.3-0.5-2.5-0.7-3.5l12.2-7.9l0.3,0.5
		c-1,2-2,4-3,6.1c-0.9,2.1-1.7,4.1-2.2,6c-0.5,2-0.8,3.9-0.7,5.7s0.5,3.6,1.4,5.3l0.5,1c0.8,1.4,1.6,2.4,2.7,3.2
		c1,0.7,2.1,1.2,3.2,1.5c1.1,0.3,2.2,0.3,3.3,0.1c1.1-0.2,2-0.5,2.9-1c1.2-0.7,2.1-1.6,2.7-2.8c0.6-1.2,1.1-2.6,1.3-4.1
		c0.3-1.6,0.4-3.3,0.4-5.1c0-1.8,0-3.7,0-5.7c0-2.2,0-4.4,0.1-6.7c0.1-2.2,0.3-4.4,0.8-6.4s1.2-3.9,2.3-5.5c1.1-1.7,2.6-3,4.5-4.1
		c2.4-1.3,4.7-1.9,7-1.9c2.3,0,4.5,0.6,6.5,1.8c2.1,1.1,4,2.7,5.9,4.8c1.9,2.1,3.6,4.5,5.1,7.3l0,0.1c0.7,1.2,1.3,2.5,1.8,3.8
		c0.5,1.3,1,2.6,1.4,3.9c0.4,1.3,0.8,2.5,1,3.7c0.3,1.2,0.5,2.3,0.7,3.3l-11.7,7.7l-0.3-0.5c0.5-0.7,1.1-1.7,1.8-3
		c0.7-1.3,1.4-2.8,2.1-4.4c0.7-1.6,1.2-3.3,1.6-5c0.4-1.8,0.6-3.4,0.6-5c-0.2-1.2-0.6-2.2-1-3.1c-0.4-0.8-0.8-1.6-1.2-2.4
		c-0.6-1-1.3-1.9-2.1-2.5c-0.8-0.6-1.7-1.1-2.6-1.3c-0.9-0.3-1.9-0.3-2.9-0.2c-1,0.1-2,0.4-2.9,1c-1.2,0.7-2,1.6-2.6,2.9
		c-0.6,1.3-0.9,2.7-1.1,4.3c-0.2,1.6-0.3,3.3-0.2,5.1c0.1,1.8,0.1,3.5,0.2,5.3c0.1,2.3,0.1,4.6,0,6.9c-0.1,2.3-0.4,4.4-0.9,6.4
		c-0.5,2-1.4,3.8-2.6,5.5C265.8,120.1,264.1,121.5,262,122.7z"
          />
          <path
            className="st0"
            d="M304.8,184.3l-15.1-0.1l0-0.4l8.4-6.9c2.9-2.3,4.5-5.9,4.6-9.6l-35.4-0.3c-5.9,0-11.6,1.5-16.7,4.5l-0.6,0
		l0.2-24.8l0.6,0c5,3.1,10.8,4.8,16.6,4.8l35.4,0.3c0-3.7-1.6-7.2-4.4-9.6l-8.4-7.1l0-0.4l15.1,0.1L304.8,184.3z"
          />
          <path
            className="st0"
            d="M239.9,251c-2.3-1.6-4.3-3.3-5.9-5.3c-1.7-1.9-3-4-4.1-6.2c-1-2.2-1.8-4.5-2.2-6.9s-0.5-4.8-0.2-7.2
		c0.3-2.5,0.9-4.9,1.8-7.4s2.2-4.9,3.9-7.3c2.5-3.5,5.3-6.4,8.4-8.6s6.5-3.6,10-4.2c3.5-0.7,7.1-0.6,10.7,0.2s7.2,2.4,10.6,4.7
		c3.4,2.3,6.1,5.1,8.1,8.2c2,3.1,3.4,6.5,4,10c0.6,3.5,0.5,7.2-0.4,10.9c-0.9,3.7-2.5,7.4-5,10.9s-5.3,6.4-8.5,8.6
		c-3.2,2.2-6.6,3.6-10.1,4.3c-3.5,0.7-7.1,0.7-10.8-0.1C246.8,254.9,243.3,253.3,239.9,251z M249.2,237.3c3.4,2.4,6.6,4.2,9.5,5.7
		c2.9,1.4,5.6,2.3,8.1,2.8c2.4,0.4,4.6,0.3,6.5-0.4c1.9-0.7,3.5-1.9,4.7-3.7c1.3-1.8,1.9-3.7,1.8-5.7c-0.1-2-0.7-4-2-6.1
		c-1.2-2.1-3.1-4.3-5.4-6.5c-2.4-2.2-5.3-4.5-8.7-6.9c-3.4-2.3-6.5-4.2-9.5-5.6c-2.9-1.4-5.6-2.3-8-2.7c-2.4-0.4-4.6-0.3-6.4,0.3
		c-1.9,0.6-3.4,1.9-4.7,3.7c-1.3,1.8-1.9,3.7-1.8,5.7c0,2,0.7,4.1,1.9,6.2c1.2,2.1,3,4.3,5.4,6.6C242.9,232.7,245.8,235,249.2,237.3
		z"
          />
          <path
            className="st0"
            d="M156.7,259l-0.3-1.1l19.7-6.4l21.7,19.1c1.1,0.9,1.4,2.5,0.7,3.7l-5.9,11.9c-2.8,5.6-0.9,12.3,4.4,15.6
		l0.2,0.6l-19.5,6.4l-0.2-0.6l3.5-5.6c1.9-3.1,3.7-6.2,5.3-9.4l5.1-10l-17-13.2C168.9,265.7,163,262,156.7,259z M198.3,262.5
		c-1.8-5.6-5.1-10.5-9.6-14.4l-0.2-0.6l23.6-7.7l0.2,0.6c-1.4,5.7-1.1,11.7,0.7,17.3l6.3,19.3c1.8,5.6,5.1,10.5,9.6,14.4l0.2,0.6
		l-23.6,7.7l-0.2-0.6c1.4-5.7,1.1-11.7-0.7-17.3L198.3,262.5z"
          />
          <path
            className="st0"
            d="M104.1,257.1l3.5-12.9l43,11.9l-0.2,0.6c-4.3,4.1-7.4,9.2-9,14.9l-5.4,19.5c-1.6,5.7-1.5,11.6,0.1,17.3
		l-0.2,0.6l-42.8-11.8l4.1-15l0.4,0.1l1.8,4c3.3,7.4,9.8,13,17.7,15.2l6.2-22.4c-4.8-1.3-9.9-0.9-14.3,1.1l-2.2,1l-0.8-0.2l4.3-15.6
		l0.8,0.2l1.6,2.7c2.5,4.2,6.5,7.3,11.3,8.6l6.6-24c-9.2-2.5-18.1-0.5-26.2,4.3C104.4,257.2,104.1,257.1,104.1,257.1z"
          />
          <path
            className="st0"
            d="M42.3,216c3.5-3,7.1-5.1,10.7-6.1c3.6-1.1,7.3-1.2,10.9-0.5c3.6,0.7,7.2,2.3,10.7,4.7
		c3.5,2.4,6.9,5.5,10.2,9.4l15.8,18.5l-0.5,0.4c-5.8,1-11.3,3.5-15.8,7.3L69,262.9c-4.4,3.8-7.7,8.7-9.6,14.3l-0.5,0.4L43.1,259
		c-3.2-3.8-5.8-7.6-7.6-11.4c-1.8-3.8-2.8-7.6-3-11.2c-0.2-3.7,0.5-7.2,2.1-10.7C36.2,222.3,38.8,219,42.3,216z M53.4,228.2
		c-3.4,2.9-6.1,5.6-8.2,8.1c-2.1,2.5-3.5,4.9-4.3,7.3c-0.8,2.3-0.9,4.6-0.3,6.8c0.5,2.2,1.8,4.4,3.7,6.7l3.3,3.9l38.3-32.7l-3.3-3.9
		c-2-2.3-4-3.9-6.1-4.8c-2.1-0.9-4.3-1.1-6.7-0.7s-4.9,1.4-7.6,3C59.5,223.3,56.6,225.5,53.4,228.2z"
          />
        </g>
      </svg>
    </Container>
  )
}

export default Stoked
